function showSpslide() {
    let splideEls = document.querySelectorAll('.splide');
    if (splideEls.length > 0) {
        splideEls.forEach(splideEl => {
            splideEl.classList.add('show');
        });
    }
}

window.addEventListener('load', function() {
    showSpslide();

    let carouselNavEl = document.getElementById('jsCarouselNav');
    if (carouselNavEl) {
        const carouselLogo = new Splide('#jsCarouselNav', {
            autoWidth: true,
            perMove: 1,
            autoplay: false,
            gap: '30px',
            speed: 500,
            arrows: true,
            pagination: false,
            breakpoints: {
                767: {
                    gap: '10px',
                },
            }
        });
        carouselLogo.mount();
    }
});